const OFFICIAL_WEBSITE_URL = 'https://aleta.castellera.cat/';

function OfficialWebsiteLink() {
    return (
        <p>
            Vols conèixer millor l’Aleta?{' '}
            <a
                href={OFFICIAL_WEBSITE_URL}
                target="_blank"
                rel="noopener noreferrer"
            >
                Visita el web oficial d’Aleta
            </a>
        </p>
    );
}

export default OfficialWebsiteLink;
